









































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';

import { APP_CONFIG } from '@/config/app-config';

import u from '@/utility/utility';

import BillOfLading from './components/BillOfLading.vue';
import DeliveryInfo from './components/DeliveryInfo.vue';

import { Lading } from '@/models/bill-of-lading';
import { Customer } from '@/models/customer';

import authService from '@/services/auth-services';
import commonService from '@/services/common-services';
import depositService from '@/services/deposit-services';

@Component({
    components: {
        Loading,
        'bill-of-lading': BillOfLading,
        'delivery-info': DeliveryInfo
    }
})
export default class AddNewDeposit extends Vue {
    private listLadings: Lading[] = [];
    private customerInfo: Customer = {};
    private isLoading = false;
    private isInvertOrder = false;
    private isFragileGoods = false;
    private isFoam = false;
    private isCheckA = false;
    private isCheckB = false;
    private guaranteeType = 0;
    private safeLevel = 0;
    private invertObject: any = {ReceiveAddress: '', SourceStoreID: 0, DestStoreID: 0, NumberOfPack: 0}
    private extraOptions = 'safe-level'

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get customerLevels() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].customerLevels;
    }

    get customerLevelsDiscount() {
        return this.customerLevels.find((cl) => cl.ID === (this.customerInfo.LevelID || 1));
    }

    get rate() {
      return this.$store.state[APP_CONFIG.stateKey.commonStore].rate;
    }

    get feeGuarantee() {
        const list = this.$store.state[APP_CONFIG.stateKey.commonStore].feeGuarantee;
        if (!list) return [];
        return list.filter((item: any) => {
            if (this.isInvertOrder) return !!item.IsExport;
            return !item.IsExport;
        });
    }

    get safeLevels() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].safeLevel;
    }

    get safeLevelDesc() {
        if (this.safeLevels) {
            const result = this.safeLevels.find(c => c.ID == this.safeLevel);

            if (result) {
            return result.Description;
            }
        }
        return '';
    }

    private onChangeOrderType(orderType: any) {
        this.isInvertOrder = orderType == 1;
    }

    private async onChangeChinaStoreID() {
        await this.getSafeLevel();
    }

    private async getFeeGuarantee() {
        const result = await commonService.getFeeGuarantee();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_FEEGUARANTEE', result.data.data);
        }
    }

    private async getSafeLevel() {
        let storeId = !this.isInvertOrder ? this.customerInfo.ChinaStoreID : this.invertObject.SourceStoreID;
        if (storeId) {
            const result = await commonService.getSafeLevelByStore(storeId);
            if (result && result.status === 200) {
                (window['getApp'] as any).$emit('SET_SAFELEVEL', result.data.data);
            }
        }
    }

    @Watch('extraOptions', { immediate: true, deep: true })
    private async watchExtraOptions() {
        if (this.extraOptions == 'optional') {
            this.safeLevel = 0;
        }
        else {
            this.isFragileGoods = false;
            this.isFoam = false;
            this.isCheckA = false;
            this.isCheckB = false;
            this.guaranteeType = 0;
        }
    }

    @Watch('isCheckA', { immediate: true, deep: true })
    private async watchIsCheckA() {
        if (this.isCheckA) {
            this.isCheckB = false;
        }
    }

    @Watch('isCheckB', { immediate: true, deep: true })
    private async watchIsCheckB() {
        if (this.isCheckB) {
            this.isCheckA = false;
        }
    }

    private async created() {
        this.getRate();
        this.getCustomersInfo();
        this.addNewGood();

        if (!this.customerLevels) {
            await this.getCustomerLevels();
        }
        if (this.feeGuarantee.length === 0) {
            await this.getFeeGuarantee();
        }
        if (!this.safeLevels) {
            await this.getSafeLevel();
        }
    }

    private async getRate() {
      const result = await commonService.exchangeRate();
      if (result && result.status === 200) {
        (window['getApp'] as any).$emit('SET_RATE', result.data.data.exchange_rate);
        (window['getApp'] as any).$emit('SET_MIN_FEEBUY', result.data.data.min_feebuy);
      }
    }

    private async getCustomersInfo() {
        if (this.userInfo.userId > 0) {
            const result = await authService.customersInfo(this.userInfo.userId);
            if(result && result.status === 200) {
                (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
                this.customerInfo = {
                    ...result.data.data
                };
            }
        }
    }

    private async getCustomerLevels() {
        const result = await commonService.getCustomerLevels();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_CUSTOMER_LEVELS', result.data.data);
        }
    }

    private async onAddRow(data: any) {
        this.checkValid();
        if (this.listLadings.filter(x => x.isValid === false).length > 0) {
            return false;
        }

        this.addNewGood();
    }

    private async submitDeposit() {
        if (!this.isInvertOrder && !this.checkValid()) {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: 'Hãy điền đầy đủ thông tin vận đơn, thông tin yêu cầu bao gồm: mã vận đơn và số kiện!',
            });
            return false;
        }
        if (this.isInvertOrder && (this.invertObject.ReceiveAddress == '' || this.invertObject.SourceStoreID == 0 || this.invertObject.DestStoreID == 0)) {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: 'Hãy điền đầy đủ địa chỉ nhận hàng và kho gửi, nhận!',
            });
            return false;
        }
        if (this.isInvertOrder && this.invertObject.NumberOfPack <= 0) {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: 'Hãy nhập số kiện hàng gửi ngược!',
            });
            return false;
        }
        if(this.isInvertOrder) {
            const newTransaction = new Lading();
            this.listLadings = [];
            for (let i = 0; i < this.invertObject.NumberOfPack; i++) {
                this.listLadings.push({...newTransaction, vbiCode: Math.random().toString(36).slice(2, 10)})
            }
        }

        this.isLoading = true;
        const dataRequest = {
            UID: this.userInfo.userId,
            Username: this.userInfo.userName,
            Status: 16,
            FeeWeightCK: this.customerLevelsDiscount ? this.customerLevelsDiscount.WeightDiscount : 0,
            ReceivePlaceID: !this.isInvertOrder ? this.customerInfo.ReceivePlaceID : this.invertObject.DestStoreID,
            ChinaStoreID: !this.isInvertOrder ? this.customerInfo.ChinaStoreID : this.invertObject.SourceStoreID,
            ReceiveAddress: !this.isInvertOrder ? null : this.invertObject.ReceiveAddress,
            PriceType: !this.isInvertOrder ? 1 : 2,
            CustomerServiceID: this.customerInfo.CustomerServiceID,
            CurentCNYVN: this.rate,
            IsFragileGoods: this.isFragileGoods,
            IsFoam: this.isFoam,
            CheckFeeType: this.isCheckA ? 1 : this.isCheckB ? 2 : 0,
            GuaranteeType: this.guaranteeType,
            SafeLevelID: this.safeLevel,
            IsCheck: this.isCheckA || this.isCheckB,
            Transactions: [
                ...this.listLadings.map((x, i) => {
                    return {
                        TransactionCode: x.binCode,
                        VbiCode: x.vbiCode,
                        ProductName: x.productName,
                        ProductImage: x.ProductImage,
                        ProductAmount: x.productAmount,
                        NumberOfPack: x.numberOfPack,
                        ProductNumber: x.productNumber,
                        Status: 1
                    }
                })
            ]
        };

        const result = await depositService.createDeposit(dataRequest);
        this.isLoading = false;
        if (result && result.status === 200 && result.data.status === 200) {
            Vue.notify({
                group: 'foo',
                type: 'success',
                title: 'Thông báo!',
                text: 'Tạo mới ký gửi thành công!',
            });
            this.$router.push({ name: 'deposit-detail', params: { id: result.data.data.ID.toString() } }).catch(() => {
                return false;
            });
        } else if (result && result.data.status === 202) {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: result.data.error,
            });
        } else {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: 'Có lỗi trong quá trình xử lý dữ liệu!',
            });
        }
    }

    private async onRemoveRow(id: string) {
        this.listLadings = this.listLadings.filter(x => x.id !== id);
    }

    private async addNewGood() {
        const item = new Lading();
        const code = this.listLadings && this.listLadings.length ? this.listLadings[this.listLadings.length - 1].binCode.split('_')[0] : '';
        let index = this.listLadings.length;
        if (this.listLadings && this.listLadings.length && this.listLadings[this.listLadings.length - 1].binCode.split('_').length == 2) {
            index = Number(this.listLadings[this.listLadings.length - 1].binCode.split('_')[1]) + 1;
        } else {
            index =  2;
        }
        if (code) {
            item.binCode = code + '_' + String(index);
        }
        this.listLadings.push(item);
    }

    private checkValid() {
        this.listLadings = this.listLadings.map(good => {
            if (u.isNullOrWhitespace(good.binCode) || !good.numberOfPack) {
                good.isValid = false;
            } else {
                good.isValid = true;
            }
            return good;
        });

        return !(this.listLadings.filter(x => x.isValid === false).length > 0);
    }
}
